module.exports = __webpack_public_path__ + "img/skillsD-4.ee9baed4.png";